import { lazy } from 'react';
var USR00001 = lazy(function () { return import('view/Project/USR/USR00001'); });
var USR00002 = lazy(function () { return import('view/Project/USR/USR00002'); });
var USR00004 = lazy(function () { return import('view/Project/USR/USR00004'); });
var USR00005 = lazy(function () { return import('view/Project/USR/USR00005'); });
var USR00006 = lazy(function () { return import('view/Project/USR/USR00006'); });
var USR_ROUTES = [
    { path: '/USR00/USR00001', component: USR00001 },
    { path: '/USR00/USR00002', component: USR00002 },
    { path: '/USR00/USR00004', component: USR00004 },
    { path: '/USR00/USR00005', component: USR00005 },
    { path: '/USR00/USR00006', component: USR00006 },
];
export default USR_ROUTES;
